import script from "./mobileFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./mobileFooter.vue?vue&type=script&setup=true&lang=js"

import "./mobileFooter.vue?vue&type=style&index=0&id=0168b176&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0168b176"]])

export default __exports__